<template>
  <panel no-button="true" title="Change your password">
    <p v-if="errors.length">Please correct the following error(s):</p>
    <ul>
      <li v-for="error in errors" :key="error" style="color: red">
        {{ error }}
      </li>
      <li v-if="changedWithSuccess" key="success" style="color: gree">
        Password changed with success
      </li>
    </ul>
    <form @submit.prevent="submit">
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-2">Current password</label>
        <div class="col">
          <input type="password" class="form-control" v-model="password.old" />
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-2">New password</label>
        <div class="col">
          <input type="password" class="form-control" v-model="password.new" />
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-2">New password confirmation</label>
        <div class="col">
          <input
            type="password"
            class="form-control"
            v-model="password.confirmation"
          />
        </div>
      </div>
      <b-button-group>
        <b-button
          :disabled="submitDisabled"
          type="submit"
          class="submit btn-yellow"
        >
          Change password
        </b-button>
      </b-button-group>
    </form>
  </panel>
</template>

<script>
import { authHeader } from '../../helpers/auth-header.helper'
export default {
  data: () => ({
    errors: [],
    password: {
      old: null,
      new: null,
      confirmation: null
    },
    submitDisabled: null,
    changedWithSuccess: null
  }),
  methods: {
    submit() {
      this.submitDisabled = true
      this.changedWithSuccess = null
      this.errors = []

      const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), ...{ 'Content-Type': 'application/json' } },
        body: JSON.stringify({
          password: this.password
        })
      }
      fetch(
        process.env.VUE_APP_API_URL + '/user/changePassword',
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            this.password = {
              old: null,
              new: null,
              confirmation: null
            }
            this.changedWithSuccess = true
          } else {
            this.errors = data.errors
          }
        })
        .catch(() => {
          this.errors = ['Something went wrong']
        })
        .finally(() => {
          this.submitDisabled = false
        })
    }
  }
}
</script>

<style></style>
